import React, { lazy, Suspense } from 'react';
import Navbar from '../features/Navbar';
import Footer from '../components/Footer';

const SlideShow1 = lazy(() => import('../features/SlideShow').then(module => ({ default: module.SlideShow1 })));
const SlideShow2 = lazy(() => import('../features/SlideShow').then(module => ({ default: module.SlideShow2 })));

const LoadingFallback = () => (
  <div className='h-screen flex items-center justify-center'>
    <h4 className='text-center text-2xl md:text-4xl font-bold'>
      Loading.....
    </h4>
  </div>
);

const Event = () => {
  return (
    <div>
      <div className='sticky top-0 z-50'>
        <Navbar />
      </div>

      <Suspense fallback={<LoadingFallback />}>
        <div>
          <div className='px-5 py-5'>
            <h1 className='text-2xl md:text-4xl font-bold'>OUR WEEKLY SERVICES</h1>
          </div>
          <section className=''>
              <SlideShow1 />
          </section>

          <div>
            <div className='px-5 pt-10 pb-3'>
              <h1 className='text-2xl md:text-4xl font-bold'>UPCOMING EVENTS!</h1>
            </div>
            <section className=''>
                <SlideShow2 />
            </section>
          </div>

          <section className='mt-[50px]'>
            <Footer />
          </section>
        </div>
      </Suspense>
    </div>
  );
};

export default Event;
